import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {fuseAnimations} from "../../../@fuse/animations";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Service} from "../models/service";
import {ServiceService} from "../services/service.service";
import {SignUpActionService} from "../services/signUpAction.service";
import {SignUpAction} from "../models/signUpAction";
import {Services} from "../models/services";

@Component({
    templateUrl: './signUpActionForm.component.html',
    styleUrls: ['./signUpActionForm.component.scss'],
    animations   : fuseAnimations
})

export class SignUpActionFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    dialogRef: any;
    availableServices: Service[];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private _matSnackBar: MatSnackBar,
        private signUpActionService: SignUpActionService,
        private serviceService: ServiceService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Actions');
    }

    ngOnInit() {
        this.serviceService.getAll().subscribe((res: Services) => {
            this.availableServices = res.items;
        }, error => {

        });

        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            actionKey: ['', Validators.required],
            validityTime: ['', Validators.required],
            isActive: [''],
            items: this.formBuilder.array([]),
        });

        if (!this.isAddMode) {
            this.signUpActionService.getById(this.id)
                .pipe(first())
                .subscribe((x: SignUpAction) => {
                    this.f.name.setValue(x.name);
                    this.f.actionKey.setValue(x.actionKey);
                    this.f.validityTime.setValue(x.validityTime);
                    this.f.isActive.setValue(x.isActive);

                    for (let i = 0; i < x.items.length; i++) {
                        this.addItem();
                        this.items().at(i).get('service').setValue(x.items[i].service.id);
                        this.items().at(i).get('quantity').setValue(x.items[i].quantity);
                    }
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createSignUpAction();
        } else {
            this.updateSignUpAction();
        }
    }

    newItem(): FormGroup {
        return this.formBuilder.group({
            service: [''],
            quantity: [''],
        });
    }

    public addItem() {
        this.items().push(this.newItem());
    }

    public removeItem(lineIdx: number) {
        this.items().removeAt(lineIdx);
    }

    public items(): FormArray {
        return this.form.get('items') as FormArray;
    }

    private createSignUpAction() {
        this.signUpActionService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Action added successfully', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Action creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updateSignUpAction() {
        this.signUpActionService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Update successful', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this._matSnackBar.open('Action update error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                    this.loading = false;
                });
    }
}
